import { TreasuryCalendar } from "@/features/treasury/treasury";

export default function TreasuryCalendarPage() {
  return <TreasuryCalendar />;
}
